import {getFreshFoodTemplates, updateTemplateQty} from "../actions/order.js";
import {setDropDown, setModal} from "../../common/actions/modal.js";

import FreshFoodTemplatePage from "../components/order/FreshFoodTemplatePage.jsx";
import {connect} from "react-redux";
import {createLocalization} from "../../common/util/localization.jsx";

import {scssVariables} from "../../common/util/config.jsx";

const mapStateToProps = () => {
    return (state) => ({
        localization: createLocalization(state),
        authentication: state.authentication,
        productView: state.order.productView,
        deviceType: state.view.deviceType,
        width: state.view.innerWidth,
        height: state.view.innerHeight-parseInt(scssVariables.menuHeight),
        templateData: state.order.freshFoodTemplateData,
        showFreshFood: state.authentication.showFreshFood,
    });
};

const mapDispatchToProps = {
    setModal,
    setDropDown,
    getFreshFoodTemplates,
    updateTemplateQty,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(FreshFoodTemplatePage);